import { userContext } from '../userManager';
import { pascalCase } from '../../utils/strings';

// beautify lead object
function transform(lead) {
  const completeName = `${lead.properties.firstName ?? ''} ${
    lead.properties.lastName ?? ''
  }`.trim();
  return {
    ...lead,
    status: pascalCase(lead.properties.hs_Lead_Status ?? ''),
    email: lead.properties.email,
    createdAt: lead.properties.createDate,
    firstName: lead.properties.firstName,
    lastName: lead.properties.lastName,
    phone: lead.properties.phone,
    message: lead.properties.message,
    origin: pascalCase(lead.properties.hs_Analytics_Source ?? ''),
    completeName: completeName || undefined,
  };
}

function prepareStatusForHubSpot(status) {
  switch (status) {
    case 'New':
      return 'NEW';
    case 'InProgress':
      return 'IN_PROGRESS';
    case 'Connected':
      return 'CONNECTED';
    case 'Unqualified':
      return 'UNQUALIFIED';
    default:
      return 'NEW';
  }
}

export const apiLeadsGet = async (crmId) => {
  const { results } = await userContext.apiCall({
    url: `/crm/leads`,
    qs: { crmid: crmId },
  });

  const leads = results.map(transform);
  return { leads };
};

export const apiLeadsPost = ({ name, email, state, phone, status, crmId }) => {
  return userContext.apiCall({
    url: `/crm/leads`,
    method: 'POST',
    noResBody: true,
    body: {
      properties: [
        { property: 'firstname', value: name },
        { property: 'email', value: email },
        { property: 'state', value: state },
        { property: 'phone', value: phone },
        { property: 'hs_lead_status', value: prepareStatusForHubSpot(status) },
        { property: 'hubspot_owner_id', value: crmId },
      ],
    },
  });
};

export const apiLeadsPatch = ({ id, name, phone, status }) => {
  return userContext.apiCall({
    url: `/crm/leads/${id}`,
    method: 'PATCH',
    noResBody: true,
    body: {
      properties: {
        firstname: name,
        phone,
        hs_lead_status: prepareStatusForHubSpot(status),
      },
    },
  });
};

export const apiTicketsPost = ({ url, email, name, subject, message, type }) => {
  return userContext.apiCall({
    url: `/crm/tickets`,
    method: 'POST',
    noResBody: true,
    body: {
      url,
      email,
      contactname: name,
      subject,
      content: message,
      type,
      source_type: 'FORM',
    },
  });
};
